module.exports = __webpack_public_path__ + "img/hr-fast-inserter-platform.e9d6d9c0.png";